import React from "react";
import PropTypes from "prop-types";
import Text from "shared/components/data-display/text/Text";
import Icon, { ICON_NAMES } from "shared/components/utils/Icon";
import { TabWrapper, TabsLI, TabsUL, Wrapper } from "./Tabs.styles";

const Tab = ({ label, icon, to, selected, ...rest }) => {
    return (
        <TabsLI>
            {label && (
                <TabWrapper isActive={selected} {...rest} to={to}>
                    {icon && <Icon name={icon} />}
                    <Text variant="Headline_5">{label}</Text>
                </TabWrapper>
            )}
        </TabsLI>
    );
};

const Tabs = ({ tabs, clickTab, selected, ...rest }) => {
    return (
        <Wrapper {...rest}>
            <TabsUL>
                {tabs.map((data) => (
                    <Tab
                        onClick={() => clickTab(data)}
                        selected={selected === data.label}
                        {...data}
                        key={data.label}
                    />
                ))}
            </TabsUL>
        </Wrapper>
    );
};

Tab.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    icon: PropTypes.oneOf(ICON_NAMES),
    to: PropTypes.string,
    selected: PropTypes.bool,
};

Tabs.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
                PropTypes.bool,
            ]),
            icon: PropTypes.oneOf(ICON_NAMES),
        })
    ),
    selected: PropTypes.string,
    clickTab: PropTypes.func,
};

export default Tabs;
